<template>
  <v-container fluid class="bg">
    <div class="aaaa">
      <div class="bbbb"></div>
      <div class="cccc"></div>
    </div>
    <!-- ===================show hotspot================== -->

    <div fluid class="show-hospot">
      <div class="sss">
        <img class="sss-show" src="../assets/1x/locationMap.png" />
      </div>

      <!-- CULTURE -->
      <div v-show="ctives == 4" class="sss">
        <img class="sss-show" src="../assets/1x/hpCulture.png" />
      </div>

      <!-- SPORTS & LEISURE -->
      <div v-show="ctives == 1" class="sss">
        <img class="sss-show" src="../assets/1x/hpSL.png" />
      </div>

      <!-- ENTERTAINMENT -->
      <div v-show="ctives == 2" class="sss">
        <img class="sss-show" src="../assets/1x/hpCasino.png" />
      </div>

      <!-- SHOPPING -->
      <div v-show="ctives == 3" class="sss">
        <img class="sss-show" src="../assets/1x/hpShop.png" />
      </div>

      <!-- EDUCATION -->
      <div v-show="ctives == 5" class="sss">
        <img class="sss-show" src="../assets/1x/hpEdu.png" />
      </div>
      <div class="info">
        <img class="imginfo" src="../assets/1x/hpif.png" />
      </div>
    </div>

    <div class="btn-control" :class="{ onoff: issbtn }">
      <v-row class="list-btn-show">
        <v-btn
          class="btn-show d-flex"
          color="red"
          @click="
            active(1);
            issbtn = !issbtn;
          "
          :class="{ active: ctives == 1 }"
        >
          <!-- @click="isShowSL =! isShowSL; isSL =! isSL" -->
          <!-- @mouseover="isSL =! isSL" @mouseout="isSL =! isSL" -->
          <img
            v-show="ctives == 1"
            width="23"
            class="icon-show"
            src="../assets/SLb.png"
          />
          <img
            v-show="!(ctives == 1)"
            width="23"
            class="icon-show"
            src="../assets/SL.png"
          />

          SPORTS & LEISURE
        </v-btn>
      </v-row>
      <v-row class="list-btn-show">
        <v-btn
          class="btn-show d-flex"
          @click="
            active(2);
            issbtn = !issbtn;
          "
          :class="{ active: ctives == 2 }"
        >
          <!-- @click="isShowCasino =! isShowCasino; isCasino =! isCasino" -->
          <!-- @mouseover="isCasino =! isCasino" @mouseout="isCasino =! isCasino" -->
          <img
            v-show="ctives == 2"
            width="23"
            class="icon-show"
            src="../assets/casinob.png"
          />
          <img
            v-show="!(ctives == 2)"
            width="23"
            class="icon-show"
            src="../assets/casino.png"
          />
          ENTERTAINMENT
        </v-btn>
      </v-row>
      <v-row class="list-btn-show">
        <v-btn
          class="btn-show d-flex"
          @click="
            active(3);
            issbtn = !issbtn;
          "
          :class="{ active: ctives == 3 }"
        >
          <!-- @click="isShowShop =! isShowShop; isShop =! isShop" -->
          <!-- @mouseover="isShop =! isShop" @mouseout="isShop =! isShop" -->
          <img
            v-show="ctives == 3"
            width="20"
            class="icon-show"
            src="../assets/shopb.png"
          />
          <img
            v-show="!(ctives == 3)"
            width="20"
            class="icon-show"
            src="../assets/shop.png"
          />
          SHOPPING
        </v-btn>
      </v-row>
      <v-row class="list-btn-show">
        <v-btn
          class="btn-show d-flex"
          @click="
            active(4);
            issbtn = !issbtn;
          "
          :class="{ active: ctives == 4 }"
        >
          <!-- @click="isShowCulture =! isShowCulture; isCulture =! isCulture" -->
          <!-- @mouseover="isCulture =! isCulture" @mouseout="isCulture =! isCulture" -->
          <img
            v-show="ctives == 4"
            width="23"
            class="icon-show"
            src="../assets/cultureb.png"
          />
          <img
            v-show="!(ctives == 4)"
            width="23"
            class="icon-show"
            src="../assets/culture.png"
          />
          CULTURE
        </v-btn>
      </v-row>
      <v-row class="list-btn-show">
        <v-btn
          class="btn-show d-flex last"
          @click="
            active(5);
            issbtn = !issbtn;
          "
          :class="{ active: ctives == 5 }"
        >
          <!-- @click="isShowEdu =! isShowEdu; isEdu =! isEdu" -->
          <!-- @mouseover="isEdu =! isEdu" @mouseout="isEdu =! isEdu" -->
          <img
            v-show="ctives == 5"
            width="20"
            class="icon-show"
            src="../assets/edub.png"
          />
          <img
            v-show="!(ctives == 5)"
            width="20"
            class="icon-show"
            src="../assets/edu.png"
          />
          EDUCATION
        </v-btn>
      </v-row>
    </div>

    <div class="btn-close" @click="issbtn = !issbtn">
      <img
        v-show="issbtn"
        width="12"
        class="icon-show"
        src="../assets/1x/locaon.png"
      />
      <img
        v-show="!issbtn"
        width="12"
        class="icon-show"
        src="../assets/1x/locaoff.png"
      />
    </div>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      // isSL: true,
      // isCasino: true,
      // isShop: true,
      // isCulture: true,
      // isEdu: true,

      // isShowSL: false,
      // isShowCasino: false,
      // isShowShop: false,
      // isShowCulture: false,
      // isShowEdu: false,

      // adsf = 1,
      show: true,
      isActive: true,
      ctives: 0,
      issbtn: false,
    };
  },
  methods: {
    active(a) {
      if (this.ctives != a) this.ctives = a;
      else this.ctives = 0;
    },
  },
};
</script>

<style scoped>
/* btn */
.bg {
  padding: 0 !important;
  overflow: hidden !important;
}

.btn-control {
  position: fixed;
  top: 55%;
  right: 5%;
  transform: translateY(-50%);
  background: #ffffff7e;
  padding: 20px;
  transition: 0.8s;
}

.btn-show {
  position: relative;
  color: #b5a36a !important;
  background-color: #3d4543 !important;
  width: 270px;
  height: 48px !important;
  margin-bottom: 10px;
  border-radius: 0 !important;
  justify-content: left !important;
  padding: 0 30px !important;
  transition: 0.3s !important;
}
.last {
  margin-bottom: 0 !important;
}
/* .btn-show:hover{
    background-color: #B5A36A !important; 
    color: #3D4543 !important;
  } */
.icon-show {
  margin-right: 20px;
}

/* <!-- ===================show hotspot================== --> */
.sss-show {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: auto;
  width: 100%;
}
.active {
  background: #b5a36a !important;
  color: #3d4543 !important;
}
/* .active:hover{
  color: #B5A36A !important; 
  background: #3D4543 !important;
} */
.imginfo {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: auto;
  width: 100%;
}
.btn-close {
  opacity: 0;
  pointer-events: none;
}

@media only screen and (max-width: 960px) {
  .sss-show {
    height:100%;
    width: auto;
  }
  .imginfo {
    height:100%;
    width: auto;
  }
  .btn-show {
    height: 30px !important;
    width: 180px;
    font-size: 10px;
    padding: 0 20px !important;
  }
  .icon-show {
  margin-right: 15px;
  max-width: 16px;
}

  .btn-close {
    opacity: 1;
    pointer-events: all;
    position: fixed;
    top: 55%;
    right: 0px;
    margin-right: -10px !important;
    transform: translateY(-50%);
  }
  .onoff {
    right: -70% !important;
  }
}
.aaaa {
  position:fixed;
  width: 100%;
  height:100%;

}
.bbbb{
  position:fixed;
  width: 50%;
  height:100%;
  background:#F7F5F0;
  left: 0;
}
.cccc{
  position:fixed;
  width: 50%;
  height:100%;
  background: #B7DAE5;
  right:0 !important;
}
</style>